import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=5a4273f6&scoped=true&"
import script from "./overview.vue?vue&type=script&lang=ts&"
export * from "./overview.vue?vue&type=script&lang=ts&"
import style0 from "./overview.vue?vue&type=style&index=0&id=5a4273f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4273f6",
  null
  
)

export default component.exports